
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604290113020",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "8777",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M838.304 774.88c71.168-83.936 109.472-190.336 109.472-300.96C947.392 212.416 735.392 0.032 473.888 0.032S0 212.416 0 473.92s212.384 473.888 473.888 473.888c68.096 0 134.624-14.304 196.512-42.944 18.944-8.128 27.072-30.176 17.408-47.584a36.48 36.48 0 0 0-33.28-20.512 56.96 56.96 0 0 0-15.872 3.104c-49.12 22.048-104.448 36.352-164.8 36.352-220.128 0-400.768-179.104-400.768-400.768 0-220.128 179.104-400.768 400.768-400.768 220.128 0 400.768 179.104 400.768 400.768 0 104.448-39.456 202.72-111.04 277.376-6.176 6.176-9.664 15.872-9.664 25.536s4.64 18.944 11.232 27.072c1.536 1.536 3.104 1.536 3.104 1.536 1.536 1.536 1.536 3.104 3.104 4.64l188.384 201.152c6.176 6.176 15.872 11.232 27.072 11.232 9.664 0 17.408-3.104 25.536-9.664 7.744-6.176 11.232-15.872 11.232-27.072 0-9.664-3.104-18.944-9.664-25.536l-175.616-186.848z m0 0",
        "p-id": "8778"
      }
    }
  ]
})
    }
  